import styles from './CreateProject.module.css';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../hooks/auth';
import Input from '../../Common/Input';
import Checkbox from '../../Common/Checkbox';
import Button from '../../Common/Button';
import ProfilePic from '../../Common/ProfilePic';
import { useAgent } from '../../../hooks/agent';
import Loading from '../../Common/Loading';
import axios from 'axios';
import { useHistory } from 'react-router';

const PeopleItem = ({ name, url }) => (
  <div className={styles['people-item']}>
    <ProfilePic width="1.5625rem" height="1.5625rem" url={url} letter={name.substring(0,1)}/>
    <p>{name}</p>
  </div>
);

function FilterItem({ role, children, ...rest }) {
  return (
    <div className={styles['filter-item']}>
      <Checkbox {...rest}/>
      {children}
      <p className={styles['filter-item-role']}>{role}</p>
    </div>
  );
}

function CreateProject({ onCancel, setPopUpMessage }) {
  const meetingContainerRef = useRef();
  const { authState } = useAuth();
  const [usersFilter, setUsersFilter] = useState('search');
  const [creating, setCreating] = useState(false);
  const history = useHistory();

  const [{ data, isLoading, isError }, doFetch] = useAgent(
    { data: [] }, 
    "https://outplexperformancemanagement.com/api/user");

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [name, setName] = useState('');
  const [query, setQuery] = useState('');
  
  const isSearchEnabled = usersFilter === 'search' ? true : false;

  function toggleUser(id) {
    if (isUserSelected(id)) {
      const listWithoutSelectedUser = selectedUsers.filter(userId => userId != id);
      setSelectedUsers(listWithoutSelectedUser);
    } else {
      setSelectedUsers([...selectedUsers, id]);
    }
  }

  async function createProject() {
    try {
      setCreating(true);
      const result = await axios.post('https://outplexperformancemanagement.com/api/project', {
        name,
        kpis: [],
        members: selectedUsers
      });

        if (result.status === 201) {
          setCreating(false);
          onCancel();
          setPopUpMessage({
            msg: `Creation successful. You can now access ${name}.`,
            style: {
              borderTop: '5px solid #208bc5',
              backgroundImage: 'linear-gradient(-180deg, #fff, #f5f8f9 99%)',
              color: '#0c6493',
              width: '300px',
              top: '120px'
            }
          })
          setTimeout(function() { 
            setPopUpMessage({
              msg: "",
              style: {}
            })
            history.go(window.location.href);
          }, 3000);
        }
        console.log(result);
    } catch (err) {
      setCreating(false);
      console.dir(err);
    }
  }

  useEffect(() => {
    setSelectedUsers([authState.userInfo._id]);
  }, [])

  function isUserSelected(id) {
    return (selectedUsers.includes(id))
  }

  function isUserDisabled(id) {
    return (authState.userInfo._id === id);
  }

  return (
    <div ref={meetingContainerRef} className={`${styles['create-meeting']}`}>
      <div className={styles['create-meeting-header']}>
        <p className={styles['header-name']}>Create a Project</p>
      </div>
      <div className={styles['create-meeting-content']}>
        <div className={styles['location']}>
          <div className={styles['address-link']}>
            <p>Choose a name for this project</p>
            <Input placeholder="Type your project's name" value={name} onChange={(e) => setName(e.target.value)}/>
          </div>
        </div>
        <div className={styles['participants']}>
          <p>Choose starting members for this project</p>
          <div className={styles['participants-header']}>
            <div className={styles['participants-search-container']}>
              <Input placeholder="Search for someone within the system"
                onChange={(e) => setQuery(e.target.value)}
                disabled={!isSearchEnabled} 
              />
            </div>
            <div className={styles['search-or-selected']}>
              <a onClick={() => setUsersFilter('search')} 
                className={usersFilter === 'search' ? styles['selected-selector'] : ''}>
                Search
              </a>
              <a onClick={() => setUsersFilter('selected')} 
                className={usersFilter === 'selected' ? styles['selected-selector'] : ''}>
                Selected <span>{selectedUsers.length}</span>
              </a>
            </div>
          </div>
          <div className={styles['search-content']}>
            <div className={styles['filter-content-items']}>
            {isError && <div>Something went wrong ...</div>}
            { usersFilter === 'search' && 
              (isLoading 
                ? ( <Loading color="#0f6695"/> )
                : (data.data
                  .filter(user => `${user.firstName} ${user.lastName}`.toLowerCase().indexOf(query.toLowerCase()) !== -1)
                  .map((user, index) => {
                    return (
                      <FilterItem key={index} role={`${isUserDisabled(user._id) ? user.role + " (You)" : user.role}`}
                        onCheck={() => toggleUser(user._id)} 
                        checked={isUserSelected(user._id)}
                        disabled={isUserDisabled(user._id)}>
                        <PeopleItem url={user.url}
                          name={`${user.firstName} ${user.lastName}`}
                        />
                      </FilterItem>
                    )
                  }))
              )
            }
            { usersFilter === 'selected' &&
              ( data.data
                .filter(user => isUserSelected(user._id))
                .map((user, index) => {
                  return (
                    <FilterItem key={index} role={`${isUserDisabled(user._id) ? user.role + " (You)" : user.role}`}
                      onCheck={() => toggleUser(user._id)} 
                      checked
                      disabled={isUserDisabled(user._id)}>
                      <PeopleItem url={user.url}
                          name={`${user.firstName} ${user.lastName}`}
                        />
                    </FilterItem>
                )})
              )
            }
            </div>
          </div>
        </div>
      </div>
      <div className={styles['create-meeting-footer']}>
        <div className={styles['create-meeting-buttons']}>
          <Button color="transparent" onClick={() => onCancel()}>Cancel</Button>
          <Button style={{ 
            minWidth: '70px',
            maxHeight: '40px',
            height: '40px'
          }} color="primary" onClick={() => createProject()}>
            {creating
              ? <Loading color="#fff"/>
              : 'Create'
            } 
          </Button>
        </div>
      </div> 
    </div>
  );
}

export default CreateProject;